module.exports = __webpack_public_path__ + "static/Apartmani-Mima-Sokobanja-6-732d4329acdd38513adfb5bdf39d7933.jpg";